import React from "react";
import "./VisaSidebarOffers.css";

const VisaSidebarOffers = () => {
  const sidebarOffers = [
    {
      id: 1,
      title: "Express Dubai Visa",
      description: "14 Days Tourist Visa",
      processing: "24-48 Hours",
      badge: "Fastest",
      type: "express",
    },
    {
      id: 2,
      title: "Thailand E-Visa",
      description: "30 Days Single Entry",
      processing: "3-5 Days",
      badge: "Popular",
      type: "evisa",
    },
    {
      id: 3,
      title: "Schengen Visa",
      description: "26 Countries Access",
      processing: "10-15 Days",
      badge: "Premium",
      type: "schengen",
    },
    {
      id: 4,
      title: "UK Visitor Visa",
      description: "6 Months Standard",
      processing: "15-20 Days",
      badge: "Reliable",
      type: "standard",
    },
    {
      id: 5,
      title: "USA B1/B2 Visa",
      description: "Business & Tourist",
      processing: "Interview Based",
      badge: "Premium",
      type: "business",
    },
    {
      id: 6,
      title: "Australia Visitor",
      description: "Up to 12 Months",
      processing: "20-25 Days",
      badge: "Popular",
      type: "longstay",
    },
  ];

  const getBadgeClass = (type) => {
    switch (type) {
      case "express":
        return "VisaSidebarOffers-badge-express";
      case "evisa":
        return "VisaSidebarOffers-badge-evisa";
      case "schengen":
        return "VisaSidebarOffers-badge-schengen";
      case "business":
        return "VisaSidebarOffers-badge-business";
      case "longstay":
        return "VisaSidebarOffers-badge-longstay";
      default:
        return "VisaSidebarOffers-badge-standard";
    }
  };

  const handleBookNow = (offer) => {
    console.log("Booking:", offer.title);
    // Add your booking logic here
  };

  return (
    <div className="VisaSidebarOffers">
      <div className="VisaSidebarOffers-header">
        <h5>🔥 Hot Visa Deals</h5>
        <p className="VisaSidebarOffers-subtitle">Special offers for you</p>
      </div>

      <div className="VisaSidebarOffers-scroll-container">
        <div className="VisaSidebarOffers-scroll">
          {sidebarOffers.concat(sidebarOffers).map((offer, index) => (
            <div
              key={`${offer.id}-${index}`}
              className="VisaSidebarOffers-card"
            >
              <div className="VisaSidebarOffers-badge-container">
                <span
                  className={`VisaSidebarOffers-badge ${getBadgeClass(
                    offer.type
                  )}`}
                >
                  {offer.badge}
                </span>
              </div>

              <div className="VisaSidebarOffers-content">
                <h6 className="VisaSidebarOffers-title">{offer.title}</h6>
                <p className="VisaSidebarOffers-description">
                  {offer.description}
                </p>

                <div className="VisaSidebarOffers-details">
                  <div className="VisaSidebarOffers-price">{offer.price}</div>
                  <div className="VisaSidebarOffers-processing">
                    ⏱️ {offer.processing}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VisaSidebarOffers;
